import {doc} from '../docs.js';
import * as THREE from "three";

doc(
    "three.scene",
    {},
    "Create a scene in three js, any objects sent to it are added to it.",
    undefined,
    {
        tags: "Graphics",
        connects: {
            object: "three.render"
        }
    }
);

export const scene = (object) => {
    let _scene = new THREE.Scene();
    return ([msg, ...args]) => {
        switch (msg) {
        case "remove":
            _scene.remove(...args);
            return [_scene];
        case "bang":
            return [_scene];
        case "clear":
            _scene.clear();
            return [_scene];
        default:
            // otherwise we add to the scene
            if (Array.isArray(msg)) {
                msg.forEach(
                    s => {
                        if (s && !_scene.children.includes(s)) {
                            _scene.add(s);
                        }
                    });
            } else {
                if (!_scene.children.includes(msg)) {
                    _scene.add(msg);
                }
            }

            return [_scene];
        }
    };
};

doc(
    "three.render",
    {
        scene: "",
        camera: "",
    },
    "Render a scene and camera",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 2,
        connects: {
            object: "three.canvas",
            inlet: "operation"
        }
    }
);
export const render = (object, camera) => {
    let mesh;
    let _material;
    let _camera = new THREE.OrthographicCamera(0, 150, 0, 150, -1, 1);
    let _scene = undefined;
    return ([scene]) => {
        if (scene === 'dispose') {
            return;
        }
        let myCamera = _camera;
        if (camera()) {
            myCamera = camera();
        } else {
        }
        if (scene !== 'bang') {
            myCamera.lookAt(scene.position);
        }
        object.lastOutput = ['render', scene, myCamera];
        object.sendMessage(
            object.outputByNumber(0),
            object.lastOutput);
    };
};


doc(
    "three.ambientLight",
    {
        color: "",
        intensity: "",
    },
    "Creates an ambient light (to be added to scene)",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 2,
    }
);

export const ambientLight = (object, intensity) => {
    let light = new THREE.AmbientLight(0xffffff, 1);
    return ([color]) => {
        if (color === "bang") {
            return [light];
        }
        light.color = color || 0xffffff;
        light.intensity = intensity() || 1;
        return [light];
    };
};

doc(
    "three.directionalLight",
    {
        color: "",
        intensity: "",
    },
    "Creates an ambient light (to be added to scene)",
    undefined,
    {
        tags: "Graphics",
        isHot: true,
        inlets: 2,
    }
);

export const directionalLight = (object, intensity) => {
    var light = new THREE.DirectionalLight(0xffffff, 1);
    light.position.setScalar(100);
    return ([color]) => {
        if (color === "bang") {
            return [light];
        }
        light.color = color || 0xffffff;
        light.intensity = intensity() || 1;
        return [light];
    };
};

const ni = (x, y) => x === undefined ? y : x;

export const sceneDefinitions = {
    "three.ambientLight": ambientLight,
    "three.directionalLight": directionalLight,
    "three.scene": scene,
    "three.render": render,
};
